module.exports = __webpack_public_path__ + "img/people_yl.f8caa337.png";